


import React, { useState, useRef, useEffect, useCallback } from "react";
import StreamText from "./StreamText";
import axios from "axios";
import Loader from "./Loader";
import { v4 as uuidv4 } from "uuid";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useAppContext } from "../Context/AppProvider";
// import useAppContext from "../Context/AppProvider";

const termsAndConditionsText = `
<p><em>Effective Date: 5/1/2025</em></p>
<p>Welcome to <strong>SmartStart AI</strong>, part of the 10 Minute CashFlow program operated by <strong>Free & Happy Inc.</strong> (“Company,” “we,” “us,” or “our”). Before you access or use SmartStart AI, please carefully read these Terms and Conditions (“Agreement”). By typing your name and continuing, you acknowledge that you have read, understood, and agreed to be bound by the following terms. If you do not agree to these terms, do not access or use SmartStart AI.</p>
<p><strong>1. Purpose of SmartStart AI</strong><br />
SmartStart AI is an educational tool designed to assist users in identifying potential cashflow opportunities based on their answers to intake questions. It is intended for informational purposes only and does not guarantee income, business success, or specific financial outcomes.</p>
<p><strong>2. Data Collection and Usage</strong><br />
By participating in SmartStart AI, you agree that we may collect, store, and process the information you provide, including but not limited to your name, location, demographic details, responses to intake questions, and any information inferred by AI interpretation systems.<br />
This data may be used for purposes including:<br />
• Generating your personalized CashFlow Plan<br />
• Improving and training SmartStart AI systems<br />
• Enhancing future courses, tools, and services<br />
• Marketing research and business development<br />
• Creating anonymized statistics and insights<br />
We will take reasonable steps to protect your data. However, you understand and agree that no system can be guaranteed completely secure.</p>
<p><strong>3. Data Storage</strong><br />
Your information may be stored in digital databases controlled by Free & Happy Inc., its technology partners, or third-party cloud providers. We retain the right to store your data indefinitely, even if you discontinue use of the course or SmartStart AI.<br />
If you would like your data removed in the future, you may contact our support team and request deletion, subject to reasonable verification requirements.</p>
<p><strong>4. Intellectual Property</strong><br />
All content generated by SmartStart AI, including your personalized CashFlow Plan, remains the intellectual property of Free & Happy Inc. You are granted a non-exclusive, non-transferable, limited right to use the content for your own personal, non-commercial purposes.<br />
You may not resell, reproduce, or redistribute any part of SmartStart AI outputs without express written permission from Free & Happy Inc.</p>
<p><strong>5. No Guarantees or Warranties</strong><br />
Free & Happy Inc. makes no warranties regarding the accuracy, completeness, or usefulness of any information provided by SmartStart AI. Your participation is voluntary and at your own risk. We do not guarantee any income, business results, or financial improvement based on your use of SmartStart AI.<br />
All cashflow strategies involve risk, and it is your responsibility to exercise due diligence, judgment, and discretion.</p>
<p><strong>6. Modifications</strong><br />
We reserve the right to modify, suspend, or discontinue SmartStart AI, or to change these Terms and Conditions at any time without notice. Updated Terms will be posted within the SmartStart AI experience or course portal.<br />
Continued use of SmartStart AI after changes constitutes acceptance of the updated Terms.</p>
<p><strong>7. Limitation of Liability</strong><br />
To the fullest extent permitted by law, Free & Happy Inc., its affiliates, and its licensors shall not be liable for any indirect, incidental, consequential, special, punitive, or exemplary damages arising out of your participation in SmartStart AI, even if advised of the possibility of such damages.</p>
<p><strong>8. Governing Law</strong><br />
This Agreement shall be governed by and construed in accordance with the laws of the State of Utah without regard to its conflict of law principles.<br />
Any disputes shall be resolved through binding arbitration in St. George, Utah.</p>
<p><strong>9. Contact Information</strong><br />
If you have questions about these Terms and Conditions, please contact us at:<br />
jd@jakeducey.com</p>
`;

const ChatWindow = () => {
    const { fetchSessions = () => {} } = useAppContext() || {};
        const [guestId, setGuestId] = useState(() => localStorage.getItem("guestId") || null);
    const userData = localStorage.getItem("userData");
    const recommendationInitiatedRef = useRef(false);
    const prevRouteSessionIdRef = useRef();
    const { sessionId: routeSessionId } = useParams();

    const [messages, setMessages] = useState([]);
    const [input, setInput] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingQuestions, setIsLoadingQuestions] = useState(true);
    const [autoScroll, setAutoScroll] = useState(true);
    const [isMessageChanged, setIsMessageChanged] = useState("");
    const [recommendedLesson, setRecommendedLesson] = useState(null);
    const [bonusLessons, setBonusLessons] = useState(null); // NEW STATE FOR BONUS LESSONS
    const [isRecommending, setIsRecommending] = useState(false); // For recommendation API call
    const [isGeneratingPdf, setIsGeneratingPdf] = useState(false); // For PDF API call
    const [questions, setQuestions] = useState([]);
    console.log("🚀 ~ ChatWindow ~ questions:", questions)
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [currentSessionId, setCurrentSessionId] = useState(routeSessionId || null);
    const [termsAccepted, setTermsAccepted] = useState(false);

    const messagesEndRef = useRef(null);
    const scrollContainerRef = useRef(null);

    const stableFetchSessions = useCallback(fetchSessions, [fetchSessions]);
    const API_BASE_URL_ADMIN = `${process.env.REACT_APP_BACKEND_URL}/api/v1/admin`;
    const API_BASE_URL_USER = `${process.env.REACT_APP_BACKEND_URL}/api/v1/user`;

    const isTermsAcceptedForSession = (sessionId) => {
        if (!sessionId) return false;
        try {
            const acceptedSessions = JSON.parse(localStorage.getItem("acceptedSessions") || "{}");
            return acceptedSessions[sessionId] === true;
        } catch (e) {
            console.error("Failed to parse acceptedSessions from localStorage", e);
            return false;
        }
    };

    const setTermsAcceptedForSessionStorage = (sessionId) => {
        if (!sessionId) return;
        try {
            const acceptedSessions = JSON.parse(localStorage.getItem("acceptedSessions") || "{}");
            acceptedSessions[sessionId] = true;
            localStorage.setItem("acceptedSessions", JSON.stringify(acceptedSessions));
        } catch (e) {
            console.error("Failed to save acceptedSessions to localStorage", e);
        }
    };

    useEffect(() => {
        if (routeSessionId) {
            if (isTermsAcceptedForSession(routeSessionId)) {
                setTermsAccepted(true);
            } else {
                setTermsAccepted(false);
                setMessages([]);
                setCurrentQuestionIndex(0);
                setRecommendedLesson(null);
                setBonusLessons(null); // RESET BONUS LESSONS
                recommendationInitiatedRef.current = false;
            }
            setCurrentSessionId(routeSessionId);
        } else {
            setTermsAccepted(false);
            setCurrentSessionId(null);
            setMessages([]);
            setCurrentQuestionIndex(0);
            setRecommendedLesson(null);
            setBonusLessons(null); // RESET BONUS LESSONS
            recommendationInitiatedRef.current = false;
        }
    }, [routeSessionId]);


    async function fetchWithRetry(apiCall, retries = 2, delay = 1000) {
        try {
            return await apiCall();
        } catch (error) {
            if (retries > 0) {
                await new Promise(resolve => setTimeout(resolve, delay));
                return fetchWithRetry(apiCall, retries - 1, delay * 2); // Exponential backoff
            }
            throw error; // Rethrow after exhausting retries
        }
    }


    useEffect(() => {
        const fetchApiQuestions = async () => {
            if (!termsAccepted) return;
            setIsLoadingQuestions(true);
            try {
                const response = await fetchWithRetry(() => axios.get(`${API_BASE_URL_ADMIN}/questions`));
                if (response.data && Array.isArray(response.data.questions)) {
                    const formattedQuestions = response.data.questions.map(q => ({
                        id: q._id,
                        system: q.question.replace(/\\n/g, '\n')
                    }));
                    setQuestions(formattedQuestions);
                } else {
                    setQuestions([]);
                    toast.error("Could not load questions: Invalid data format received.");
                }
            } catch (error) {
                console.error("Error fetching questions from API:", error);
                toast.error("Failed to load questions. Please refresh or try again later.");
                setQuestions([]);
            } finally {
                setIsLoadingQuestions(false);
            }
        };
        fetchApiQuestions();
    }, [termsAccepted, API_BASE_URL_ADMIN]);

    const handleAcceptTerms = () => {
        let sessionIdToUse = routeSessionId || currentSessionId;
        if (!sessionIdToUse) {
            sessionIdToUse = uuidv4();
            if (!routeSessionId) {
                window.history.pushState({}, "", `/chat/${sessionIdToUse}`);
            }
        }
        setCurrentSessionId(sessionIdToUse);
        setTermsAccepted(true);
        setTermsAcceptedForSessionStorage(sessionIdToUse);
    };

    useEffect(() => {
        if (prevRouteSessionIdRef.current !== routeSessionId) {
            recommendationInitiatedRef.current = false;
        }
        prevRouteSessionIdRef.current = routeSessionId;

        const initOrFetchConversation = async (sessionIdToFetch) => {
            setMessages([]);
            setIsLoading(true); // General loading for conversation
            try {
                if (!sessionIdToFetch) {
                    if (questions.length > 0) {
                        setMessages([{ type: "bot", text: questions[0].system, isStreaming: true }]);
                        setCurrentQuestionIndex(0);
                    } else {
                        setMessages([{ type: "bot", text: "Welcome! Questions are not available at the moment. Please try refreshing.", isStreaming: false }]);
                    }
                } else {
                    const res = await fetchWithRetry(() => axios.get(`${API_BASE_URL_USER}/get-conversation/${sessionIdToFetch}`));
                    const responseData = res.data?.responseData;

                    if (!responseData || !responseData.conversation || responseData.conversation.length === 0) {
                        if (questions.length > 0) {
                            setMessages([{ type: "bot", text: questions[0].system, isStreaming: true }]);
                            setCurrentQuestionIndex(0);
                        } else {
                            setMessages([{ type: "bot", text: "Welcome! No prior conversation found. Questions are not available. Please try refreshing.", isStreaming: false }]);
                        }
                    } else {
                        const fetchedConvoItems = responseData.conversation;
                        const newLoadedMessages = [];
                        let answeredCount = 0;
                        for (const item of fetchedConvoItems) {
                            newLoadedMessages.push({ type: "bot", text: item.system, isStreaming: false });
                            if (item.user != null) {
                                newLoadedMessages.push({ type: "user", text: item.user });
                                answeredCount++;
                            } else break;
                        }
                        setMessages(newLoadedMessages);
                        setCurrentQuestionIndex(answeredCount);
                        if (stableFetchSessions) stableFetchSessions();

                        const isQuestionnairePreviouslyCompleted = responseData.isComplete ||
                            (questions.length > 0 && answeredCount >= questions.length);

                        if (isQuestionnairePreviouslyCompleted) {
                            if (!recommendationInitiatedRef.current && !isRecommending && !isGeneratingPdf) {
                                recommendationInitiatedRef.current = true;
                                setTimeout(() => fetchAndRecommendLesson(sessionIdToFetch, true), 50);
                            }
                        } else if (questions.length > 0 && answeredCount < questions.length) {
                            const lastUserMsg = newLoadedMessages[newLoadedMessages.length - 1]?.type === "user";
                            if (lastUserMsg && questions[answeredCount]) {
                                setMessages(prev => [...prev, { type: "bot", text: questions[answeredCount].system, isStreaming: true }]);
                            }
                        } else if (answeredCount > 0 && questions.length === 0 && !isQuestionnairePreviouslyCompleted) {
                            setMessages(prev => [...prev, { type: "bot", text: "Your previous conversation has been loaded, but the questionnaire structure is currently unavailable.", isStreaming: false }]);
                        }
                    }
                }
            } catch (err) {
                console.error("Error fetching or initializing conversation:", err);
                toast.error("Failed to load conversation. Starting a new chat if possible.");
                if (questions.length > 0) setMessages([{ type: "bot", text: questions[0].system, isStreaming: true }]);
                else setMessages([{ type: "bot", text: "Sorry, an error occurred. Unable to start chat.", isStreaming: false }]);
            } finally {
                setIsLoading(false);
            }
        };

        if (termsAccepted && !isLoadingQuestions && currentSessionId) {
            if (messages.length === 0 || (routeSessionId && routeSessionId !== prevRouteSessionIdRef.current)) {
                initOrFetchConversation(currentSessionId);
            }
        } else if (termsAccepted && !isLoadingQuestions && !currentSessionId && questions.length > 0) {
            initOrFetchConversation(null);
        }
    }, [currentSessionId, termsAccepted, isLoadingQuestions, questions, routeSessionId, stableFetchSessions, isRecommending, isGeneratingPdf]);

    const handleSend = async () => {
        const userInput = input.trim();
        if (!userInput || !termsAccepted || isLoading || isRecommending || isGeneratingPdf || (recommendedLesson && recommendedLesson.length > 0)) {
            return;
        }

        const currentQ = questions && questions[currentQuestionIndex];
        if (!currentQ) {
            if (!recommendedLesson || recommendedLesson.length === 0) {
                toast.info("Questionnaire finished or no questions available. Recommendations might be pending or failed.");
            }
            return;
        }

        setInput("");
        let sessionIdToUse = currentSessionId;
        if (!sessionIdToUse) {
            sessionIdToUse = uuidv4();
            if (!routeSessionId) window.history.pushState({}, "", `/chat/${sessionIdToUse}`);
            setCurrentSessionId(sessionIdToUse);
            setTermsAcceptedForSessionStorage(sessionIdToUse);
        }

        setMessages(prev => [...prev.filter(msg => !(msg.type === "bot" && msg.isLoading)), { type: "user", text: userInput }]);
        setMessages(prev => [...prev, { type: "bot", isLoading: true, text: "" }]); // General bot thinking loader
        setIsLoading(true); // For chat send

        const currentSystemPrompt = currentQ.system;
        const payload = { content: userInput, sessionId: sessionIdToUse, userId: JSON.parse(userData)?.id, prompt: currentSystemPrompt };

        axios.post(`${API_BASE_URL_USER}/chat`, payload)
            .then((response) => {
            console.log("🚀 ~ .then ~ response:", response)
                  const newGuestId = response.data.guestId;
                if (newGuestId) {
                     setGuestId(newGuestId);
                    localStorage.setItem("guestId", newGuestId);
                   
                }
                
                const newCurrentQuestionIndex = currentQuestionIndex + 1;
                setCurrentQuestionIndex(newCurrentQuestionIndex);
                const isQuestionnaireComplete = questions.length > 0 && newCurrentQuestionIndex >= questions.length;

                setMessages(prevMessages => {
                    let updatedMessages = prevMessages.filter(msg => !(msg.type === "bot" && msg.isLoading && !msg.isRecommendationLoader && !msg.isPdfGenerationLoader)); // Keep specific loaders
                    if (!isQuestionnaireComplete && questions.length > 0 && questions[newCurrentQuestionIndex]) {
                        updatedMessages.push({ type: "bot", text: questions[newCurrentQuestionIndex].system, isStreaming: true });
                    }
                    return updatedMessages;
                });

                if (isQuestionnaireComplete) {
                    if (!recommendationInitiatedRef.current && !isRecommending && !isGeneratingPdf) {
                        recommendationInitiatedRef.current = true;
                        fetchAndRecommendLesson(sessionIdToUse);
                    }
                }
            })
            .catch((error) => {
                console.error("Error sending message to /chat:", error);
                const errorMessage = error.response?.data?.error || error.response?.data?.message || "Failed to send message.";
                toast.error(errorMessage.toLowerCase().includes("limit exceeded") ? "Your session has expired." : errorMessage);
                setMessages(prev => prev.filter(msg => !(msg.type === "bot" && msg.isLoading && !msg.isRecommendationLoader && !msg.isPdfGenerationLoader)));
                recommendationInitiatedRef.current = false;
            })
            .finally(() => setIsLoading(false));
    };

    const fetchAndRecommendLesson = async (sessionId, skipInitialLoader = false) => {
        if (!sessionId) return;

        // If lessons are already in messages (e.g., on page reload), just rehydrate state and PDF link if present
        if (skipInitialLoader && messages.some(m => m.isRecommendation)) {
            // This rehydration logic needs to be robust if you want to fully restore state
            // It's safer to just re-fetch the recommendations if the full state isn't easily reconstructible
            // For now, if recommendedLesson is null, we can still try to set it from existing messages
            if (!recommendedLesson) {
                const recsFromMessages = messages
                    .filter(m => m.isRecommendation && !m.isBonusRecommendation) // Exclude bonus if you want separate state
                    .map(m => ({
                        lessonNumber: m.lessonNumber,
                        name: m.lessonName,
                        link: m.linkUrl,
                        // You'd need to store ALL original properties if you want full rehydration for PDF
                        // For simplicity, we'll let the API re-fetch if recommendedLesson is null.
                    }));
                if (recsFromMessages.length > 0) setRecommendedLesson(recsFromMessages);
            }
            if (!bonusLessons) { // Rehydrate bonus lessons
                const bonusRecsFromMessages = messages
                    .filter(m => m.isBonusRecommendation)
                    .map(m => ({
                        lessonNumber: m.lessonNumber,
                        name: m.lessonName,
                        link: m.linkUrl,
                        // Again, need all original properties for PDF
                    }));
                if (bonusRecsFromMessages.length > 0) setBonusLessons(bonusRecsFromMessages);
            }
            // We don't re-trigger PDF download here if link is already in messages.
            return;
        }

        setIsRecommending(true);
        setMessages(prev => [
            ...prev.filter(msg => !(msg.type === "bot" && msg.isLoading && !msg.isRecommendationLoader && !msg.isPdfGenerationLoader)),
            { type: "bot", text: "Analyzing your responses and generating your plan...", isLoading: true, isStreaming: false, isRecommendationLoader: true }
        ]);

        try {
            const convoResponse = await axios.get(`${API_BASE_URL_USER}/get-conversation/${sessionId}`);
            if (!convoResponse.data.responseData || !convoResponse.data.responseData.conversation) {
                throw new Error("Failed to fetch conversation data for recommendation. The existing conversation might be incomplete or missing.");
            }
            const conversationForRecommendation = convoResponse.data.responseData.conversation.map(item => ({
                system: item.system, user: item.user,
            }));
            const recommendPayload = { sessionId: sessionId, conversation: conversationForRecommendation,guestId: guestId};

            const recommendRes = await axios.post(`${API_BASE_URL_USER}/recommend-lesson`, recommendPayload);
            setMessages(prev => prev.filter(msg => !msg.isRecommendationLoader)); // Remove recommendation loader
            setIsRecommending(false); // Recommendation part done

            if (recommendRes.data) {
                const apiRecommendations = recommendRes.data.recommended_lessons || [];
                const apiBonusLessons = recommendRes.data.bonus_lessons || []; // GET BONUS LESSONS
                const userCriteriaForPdf = recommendRes.data.user_criteria_debug;

                setRecommendedLesson(apiRecommendations); // Store full API recommendations for PDF payload
                setBonusLessons(apiBonusLessons); // STORE BONUS LESSONS

                if (apiRecommendations.length === 0 && apiBonusLessons.length === 0) {
                     setMessages(prev => [...prev, { type: "bot", text: recommendRes.data.message || "No lessons match your specific criteria. Please try adjusting your preferences.", isStreaming: false }]);
                } else {
                    setMessages(prev => [...prev, { type: "bot", text: "Great! Based on your answers, here are some top recommendations for you:", isStreaming: false }]);

                    apiRecommendations.forEach((rec, index) => {
                        setMessages(prev => [...prev, {
                            type: "bot",
                            displayText: (
                                <div className="flex items-start gap-2">
                                    <span className="text-sm md:text-base font-semibold text-gray-700 dark:text-gray-300">{index + 1}.</span>
                                    <a
                                        href={rec.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-blue-600 dark:text-blue-400 underline hover:text-blue-800 dark:hover:text-blue-200 transition-colors duration-200"
                                        aria-label={`Recommended lesson ${rec.lessonNumber}: ${rec.name}`}
                                    >
                                        {/* <span className="font-semibold text-blue-800 dark:text-blue-300">{rec.lessonNumber}.</span>{" "} */}
                                        <span className="font-medium">"{rec.name}"</span>
                                    </a>
                                </div>
                            ),
                            linkUrl: rec.link,
                            isRecommendation: true,
                            lessonNumber: rec.lessonNumber,
                            lessonName: rec.name, // Use name as lessonName for consistency
                            theme: rec.theme, // If theme is always present
                            isStreaming: false
                        }]);
                    });

                    // --- DISPLAY BONUS LESSONS ---
                    if (apiBonusLessons.length > 0) {
                        setMessages(prev => [...prev, { type: "bot", text: "If you took the special offer for the extra 12 lessons, here are some bonus options for you.  If you didn’t, and you’ve changed your mind, you can still get access below.", isStreaming: false, isBonusHeader: true }]); // Custom flag for styling
                        apiBonusLessons.forEach((rec, index) => {
                            setMessages(prev => [...prev, {
                                type: "bot",
                                displayText: (
                                    <div className="flex items-start gap-2">
                                        <span className="text-sm md:text-base font-semibold text-gray-700 dark:text-gray-300">{index + 1}.</span>
                                        <a
                                            href={rec.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-purple-600 dark:text-purple-400 underline hover:text-purple-800 dark:hover:text-purple-200 transition-colors duration-200"
                                            aria-label={`Bonus lesson ${rec.lessonNumber}: ${rec.name}`}
                                        >
                                            {/* <span className="font-semibold text-purple-800 dark:text-purple-300">{rec.lessonNumber}.</span>{" "} */}
                                            <span className="font-medium">"{rec.name}"</span>
                                        </a>
                                    </div>
                                ),
                                linkUrl: rec.link,
                                isRecommendation: true,
                                isBonusRecommendation: true, // Specific flag for bonus lessons
                                lessonNumber: rec.lessonNumber,
                                lessonName: rec.name,
                                theme: rec.theme,
                                isStreaming: false
                            }]);
                        });
                    }
                }


                // ---- PDF DOWNLOAD LOGIC ----
                // Only attempt PDF if there are main recommendations OR bonus recommendations
                if (userCriteriaForPdf && (apiRecommendations.length > 0 || apiBonusLessons.length > 0)) {
                    setIsGeneratingPdf(true);
                    setMessages(prev => [...prev, { type: "bot", text: "Generating your personalized CashFlow Plan PDF...", isLoading: true, isStreaming: false, isPdfGenerationLoader: true }]);

                    try {
                        const pdfPayload = {
                            userCriteria: userCriteriaForPdf,
                            recommendedLessons: apiRecommendations, // Send full recommendations
                            bonusLessons: apiBonusLessons // SEND BONUS LESSONS TO PDF GENERATOR
                        };
                        const pdfRes = await axios.post(`${API_BASE_URL_USER}/download-cashflow-plan`, pdfPayload);

                        setMessages(prev => prev.filter(msg => !msg.isPdfGenerationLoader));

                        if (pdfRes.data && pdfRes.data.pdf_url) {
                            const pdfDownloadUrl = pdfRes.data.pdf_url;
                            setMessages(prev => [...prev, { type: "bot", text: "\nYou can view your full personalized CashFlow Plan PDF.", isStreaming: false }]);
                            setMessages(prev => [...prev, {
                                type: "bot", text: `[Download Your CashFlow Plan PDF](${pdfDownloadUrl})`,
                                isPdfLink: true, pdfLinkUrl: pdfDownloadUrl, isStreaming: false,
                            }]);
                        } else {
                            console.warn("PDF download API call succeeded but no pdf_url was returned.", pdfRes.data);
                            setMessages(prev => [...prev, { type: "bot", text: "\nA detailed PDF plan could not be generated at this moment (no URL received).", isStreaming: false, isError: true }]);
                        }
                    } catch (pdfError) {
                        console.error("Error calling /download-cashflow-plan:", pdfError);
                        setMessages(prev => prev.filter(msg => !msg.isPdfGenerationLoader));
                        const pdfErrorMessage = pdfError.response?.data?.message || pdfError.message || "Failed to generate PDF plan.";
                        setMessages(prev => [...prev, { type: "bot", text: `\nError generating PDF: ${pdfErrorMessage}`, isStreaming: false, isError: true }]);
                    } finally {
                        setIsGeneratingPdf(false);
                    }
                } else {
                     setMessages(prev => [...prev, { type: "bot", text: "\nCould not generate PDF plan due to missing criteria or recommendations.", isStreaming: false, isError: true }]);
                }
            } else { // No data from recommendRes.data or other unexpected response
                let errorMessage = "Sorry, I couldn't find any specific lesson recommendations for you right now.";
                if (recommendRes.data?.message) errorMessage = recommendRes.data.message;
                setMessages(prev => [...prev, { type: "bot", text: errorMessage, isStreaming: false, isError: true }]);
                setRecommendedLesson([]);
                setBonusLessons([]); // Ensure bonus lessons are also cleared
            }
        } catch (err) {
            console.error("Error during lesson recommendation:", err);
            const errorMsg = err.response?.data?.message || err.message || "Could not recommend lessons.";
            toast.error(errorMsg);
            setMessages(prev => [...prev.filter(msg => !msg.isRecommendationLoader), { type: "bot", text: `Error generating recommendations: ${errorMsg}`, isStreaming: false, isError: true }]);
            setRecommendedLesson([]);
            setBonusLessons([]); // Ensure bonus lessons are also cleared on error
            setIsRecommending(false); // Ensure this is reset on error
        }
    };


    useEffect(() => {
        if (autoScroll && messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
        setIsMessageChanged(Date.now().toString());
    }, [messages, autoScroll]);

    useEffect(() => {
        const container = scrollContainerRef.current;
        const handleScroll = () => {
            if (!container) return;
            const { scrollTop, scrollHeight, clientHeight } = container;
            const isAtBottom = scrollHeight - scrollTop <= clientHeight + 30;
            setAutoScroll(isAtBottom);
        };
        if (container) {
            container.addEventListener("scroll", handleScroll);
            setTimeout(handleScroll, 0);
        }
        return () => {
            if (container) container.removeEventListener("scroll", handleScroll);
        };
    }, [isMessageChanged]);


    if (!termsAccepted) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.8)', zIndex: 9999 }}>
                <div style={{ background: 'white', padding: '30px', borderRadius: '8px', maxWidth: '600px', width: '90%', textAlign: 'center', boxShadow: '0 4px 15px rgba(0,0,0,0.2)' }}>
                    <h2 style={{ marginBottom: '20px', fontSize: '1.5em', color: '#333' }}>SmartStart AI Terms & Conditions</h2>
                    <div style={{ marginBottom: '25px', fontSize: '0.9em', color: '#333', textAlign: 'justify', maxHeight: '350px', overflowY: 'auto', border: '1px solid #eee', padding: '15px', lineHeight: '1.6', overflowWrap: 'break-word', wordBreak: 'break-word', width: '100%', backgroundColor: '#fff', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)' }}
                        dangerouslySetInnerHTML={{ __html: termsAndConditionsText }} />
                    <button onClick={handleAcceptTerms} style={{ padding: '12px 25px', background: '#007BFF', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '1em', fontWeight: 'bold' }}>
                        I Agree
                    </button>
                </div>
            </div>
        );
    }
    if (isLoadingQuestions && termsAccepted) {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', backgroundColor: '#f5f5f5' }}>
                <Loader status={true} />
                <p style={{ marginTop: '10px', color: '#333' }}>Loading questions, please wait...</p>
            </div>
        );
    }

    return (
        <main className="flex-1 bg-[#f5f5f5] dark:bg-[#0a0a0a] flex flex-col" style={{ height: '100vh', overflow: 'hidden' }}>
            <div ref={scrollContainerRef} className="flex-1 p-4 md:p-8 !pt-[70px] space-y-4 overflow-y-auto m-2 md:m-5 mb-0 bg-white dark:bg-[#262626] rounded-md shadow-sm">
                {messages?.map((msg, i) => (
                   <div
  className={`w-fit max-w-[80%] p-4 rounded-xl text-sm md:text-base break-words break-anywhere ${
    msg.type === "user"
      ? "bg-blue-500 dark:bg-blue-700 text-white self-end ml-auto"
      : msg.isError
        ? "bg-red-100 dark:bg-red-800 border border-red-300 dark:border-red-600 text-red-700 dark:text-red-200 self-start mr-auto"
        : "bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white self-start mr-auto shadow-sm"
  }`}
  style={{ wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal' }}
>
  {msg.type === "user" ? (
    msg.text
  ) : (
    <>
      <Loader status={msg.isLoading && !msg.isRecommendationLoader && !msg.isPdfGenerationLoader || false} />
      {!msg.isLoading && (
        msg.isStreaming && !msg.isRecommendation && !msg.isPdfLink && !msg.isBonusHeader ? ( // Exclude bonus header from StreamText
          <StreamText setIsLoading={setIsLoading} setIsMessageChanged={setIsMessageChanged} fullText={msg.text ?? ""} />
        ) : msg.isRecommendation && msg.linkUrl ? (
            // Differentiate bonus lessons visually if desired, e.g., different color
            msg.isBonusRecommendation ? (
                <a
                    href={msg.linkUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-purple-600 dark:text-purple-400 underline hover:text-purple-800 dark:hover:text-purple-200 font-semibold transition-colors duration-200 flex items-center gap-1"
                    aria-label={`Bonus lesson ${msg.lessonNumber}: ${msg.lessonName}`}
                >
                    {msg.displayText}
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                </a>
            ) : ( // Regular recommendation
                <a
                    href={msg.linkUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 dark:text-blue-400 underline hover:text-blue-800 dark:hover:text-blue-200 font-semibold transition-colors duration-200 flex items-center gap-1"
                    aria-label={`Recommended lesson ${msg.lessonNumber}: ${msg.lessonName}`}
                >
                    {msg.displayText}
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                </a>
            )
        ) : msg.isPdfLink && msg.pdfLinkUrl ? (
          <a href={msg.pdfLinkUrl} target="_blank" rel="noopener noreferrer" className="text-blue-600 dark:text-blue-400 hover:underline font-semibold">
            {msg.text.match(/\[(.*?)\]/)?.[1] || "View PDF Plan"}
          </a>
        ) : (
            // Handle plain text messages, including the new bonus header
            msg.isBonusHeader ? (
                <span className="font-bold text-gray-900 dark:text-white" style={{ marginTop: '20px', display: 'block' }}>{msg.text}</span>
            ) : (
                msg.text
            )
        )
      )}
      {(msg.isRecommendationLoader || msg.isPdfGenerationLoader) && msg.isLoading && (
        <>
          <Loader status={true} size="small" inline={true} />
          <span style={{ marginLeft: '8px' }}>{msg.text}</span>
        </>
      )}
    </>
  )}
</div>
                ))}
                <div ref={messagesEndRef} />
            </div>

            <div className="p-3 md:p-5 flex items-center gap-2 border-t border-gray-200 dark:border-gray-700 bg-white dark:bg-[#262626]">
                <input
                    type="text"
                    placeholder={
                        isLoading ? "Waiting..." :
                            isRecommending ? "Analyzing responses..." :
                                isGeneratingPdf ? "Generating PDF..." :
                                    (recommendedLesson && recommendedLesson.length > 0)
                                        ? "Your lesson plan is ready. See above or download the PDF."
                                        : (questions.length > 0 && currentQuestionIndex < questions.length && messages?.some(m => m.type === 'bot' && !m.isLoading && m.text === questions[currentQuestionIndex]?.system)
                                            ? "Your answer..."
                                            : (termsAccepted && questions.length === 0 && !isLoadingQuestions) ? "No questions loaded. Try refreshing."
                                            : (questions.length > 0 && currentQuestionIndex >= questions.length && !isRecommending && !isGeneratingPdf && (!recommendedLesson || recommendedLesson.length === 0) ? "All questions answered. Waiting for plan..."
                                            : "Type a message..."))
                    }
                    className={`flex-1 bg-transparent dark:text-white border ${
                        messages.find(m => m.isError && m.type === 'bot' && messages.indexOf(m) === messages.length - 1) ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 dark:border-gray-600 focus:ring-blue-500'
                    } rounded-md px-4 py-3 focus:outline-none `}
                    value={input}
                    disabled={
                        isLoading ||
                        isRecommending ||
                        isGeneratingPdf ||
                        !termsAccepted ||
                        (termsAccepted && isLoadingQuestions) ||
                        (currentQuestionIndex >= questions.length && !isRecommending && !isGeneratingPdf && (!recommendedLesson || recommendedLesson.length === 0)) ||
                        (recommendedLesson && recommendedLesson.length > 0)
                    }
                    onChange={(e) => setInput(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter" && !isLoading && !isRecommending && !isGeneratingPdf && input.trim() && !(recommendedLesson && recommendedLesson.length > 0)) {
                            e.preventDefault();
                            handleSend();
                        }
                    }}
                />
                <button
                    disabled={
                        isLoading ||
                        isRecommending ||
                        isGeneratingPdf ||
                        !input.trim() ||
                        !termsAccepted ||
                        (termsAccepted && isLoadingQuestions) ||
                        (currentQuestionIndex >= questions.length && !isRecommending && !isGeneratingPdf && (!recommendedLesson || recommendedLesson.length === 0)) ||
                        (recommendedLesson && recommendedLesson.length > 0)
                    }
                    onClick={handleSend}
                    className="bg-blue-600 text-white px-6 py-3 min-w-[88px] h-[50px] rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 disabled:opacity-60 disabled:cursor-not-allowed transition-colors duration-150"
                >
                    {isLoading || isRecommending || isGeneratingPdf ? <Loader status={true} size="20" /> : "Send"}
                </button>
            </div>
        </main>
    );
};

export default ChatWindow;